<div class="position-relative payment-history w-100">
    <div class="d-flex w-100">
        <app-back-button class="back-button"> BACK </app-back-button>
        <div class="p-4 pt-5 d-flex flex-column w-100">
            <div class="pt-3 mat-headline-5">Payment history</div>
            <div class="mat-elevation-z4 p-3 rounded-1 position-relative mx-4 mb-3">
                @if (isLoadingResults) {
                    <div class="loading-shade">
                        <div class="flex-row d-flex justify-content-around align-items-center mt-5">
                            <mat-spinner diameter="24" class="me-2" />
                            Searching for your latest information
                        </div>
                    </div>
                }
                <div class="d-flex flex-column flex-md-row align-items-center">
                    <app-search-history
                        class="col-12 col-md-5 pe-2"
                        [isLoading]="isSearching"
                        (eventOnSubmitSearch)="eventOnSubmitSearch($event)"
                        (eventOnResetField)="eventOnResetField()"
                    />

                    <app-date-range
                        [isLoading]="isLoadingResults"
                        (eventOnChangeRange)="eventOnChangeRange($event)"
                        (eventInitialRange)="eventInitialRange($event)"
                        class="col-12 col-md-5 pe-2"
                    />

                    <button
                        class="col-12 col-md-2 button-refresh align-self-start mb-3 mb-md-0"
                        matButton="outlined"
                        appMatStrokedButtonBorder
                        color="primary"
                        (click)="refresh()"
                        [disabled]="isLoadingResults"
                    >
                        <mat-icon class="material-symbols-outlined">sync</mat-icon>
                        REFRESH
                    </button>
                </div>

                <app-table-bar-selections>
                    <div class="d-flex flex-grow-1 flex-row align-items-center px-2">
                        <div class="flex-grow-1 text-end pe-3 mat-subtitle-2">
                            {{ selection.selected.length }} ITEM(S) SELECTED
                        </div>
                        <button mat-button color="primary" (click)="donwloadMultipleFiles()" *appHideDownload>
                            DOWNLOAD
                        </button>
                    </div>
                </app-table-bar-selections>

                <div class="table-container">
                    <table
                        [dataSource]="data"
                        mat-table
                        matSort
                        matSortDisableClear
                        class="mat-elevation-z8 demo-table"
                    >
                        <!-- Checkbox Column -->
                        <ng-container matColumnDef="select">
                            <th mat-header-cell *matHeaderCellDef>
                                <mat-checkbox
                                    (change)="$event ? toggleAllRows() : null"
                                    [checked]="selection.hasValue() && isAllSelected()"
                                    [indeterminate]="selection.hasValue() && !isAllSelected()"
                                    [aria-label]="checkboxLabel()"
                                />
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <mat-checkbox
                                    (click)="$event.stopPropagation()"
                                    (change)="$event ? selection.toggle(row) : null"
                                    [checked]="selection.isSelected(row)"
                                    [aria-label]="checkboxLabel(row)"
                                />
                            </td>
                        </ng-container>

                        @for (column of columns; let columnIndex = $index; track columnIndex) {
                            <ng-container [matColumnDef]="column.columnDef">
                                <th
                                    mat-header-cell
                                    *matHeaderCellDef
                                    [mat-sort-header]="column.isSorteable ? column.columnDef : ''"
                                    [disabled]="!column.isSorteable"
                                >
                                    {{ column.header }}
                                </th>
                                <td mat-cell *matCellDef="let row">
                                    @if (column.link?.path) {
                                        <a
                                            [href]="column.link?.path + '/' + column.cell(row)"
                                            id="payment-details-link"
                                            >{{ column.cell(row) }}</a
                                        >
                                    } @else {
                                        {{ dataAccessor(column, row) }}
                                    }
                                </td>
                            </ng-container>
                        }

                        <ng-container matColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef>Actions</th>
                            <td mat-cell *matCellDef="let row">
                                <div class="d-flex flex-row align-items-center">
                                    <app-download-confirmation-icon [payment]="row" class="me-2" />
                                    <app-print-confirmation-icon [payment]="row" />
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

                        <!-- No data -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                                @if (!isLoadingResults) {
                                    <app-empty-history-table [filter]="filter" />
                                }
                            </td>
                        </tr>
                    </table>
                    <mat-paginator
                        [ngClass]="!isLoadingResults ? 'viible' : 'invisible'"
                        showFirstLastButtons
                        [length]="resultsLength"
                        [pageSizeOptions]="[10, 15, 20]"
                        aria-label="Select page of completed payments"
                    />
                </div>
            </div>
        </div>
    </div>
</div>
